/* eslint-disable camelcase */
import { useMemo, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab } from 'react-bootstrap';
import MitreContext from './MitreContext';

import './MitreTabs.scss';

const MitreTabs = ({ className, children }) => {
    const {
        mitreData,
        onSelectMitreChange,
    } = useContext(MitreContext);

    const { t, ready } = useTranslation();
    const [activeKey, setActiveKey] = useState('mitre');

    const definedTabs = useMemo(() =>
        [
            {
                key: 'mitre',
                title: t('Enterprise Matrix')
            },
            {
                key: 'mitre_ics',
                title: t('ICS Matrix')
            },
            {
                key: 'mitre_mobile',
                title: t('Mobile Matrix')
            }
        ], [t]);

    const tabs = useMemo(() => {
        return definedTabs.map((tab) => ({ ...tab, data: [] }));
    }, [t]);

    const mitreScanTabs = useMemo(() => {
        if (tabs?.length) {
            return <Tabs activeKey={activeKey} onSelect={(key) => {
                setActiveKey(key);
                if (activeKey !== key && onSelectMitreChange) {
                    onSelectMitreChange(key);
                }
            }}>
                {tabs.map((tab, index) => {
                    return <Tab key={index} title={tab.title} eventKey={tab.key}/>;
                })}
            </Tabs>;
        }
    }, [tabs, mitreData, activeKey, onSelectMitreChange, t]);

    const tabContentDOM = useMemo(() => {
        return children;
    }, [children, activeKey, tabs]);

    if (!ready) {
        return null;
    }

    return <section className={classNames(className, 'mitreTabs')}>
        {mitreScanTabs}
        {tabContentDOM}
    </section>;
};

MitreTabs.propTypes = {
    children: PropTypes.node,
    className: PropTypes.any,
};

export default MitreTabs;
